import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  MobileBody1,
  MobileBody2,
  MobileHeader1,
  MobileTitle1,
  MobileTitle2,
  WebBody1,
  WebBody2,
  WebHeader1,
  WebTitle1,
  WebTitle2,
} from "@/system/day/font/font";
import { mHeader1, swc, wHeader2 } from "@teamsparta/design-system";
import { grayScale } from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const Title = styled.h1`
  ${mHeader1};
  width: 328px;
  margin: 0 auto;
  ${DESKTOP} {
    width: initial;
    ${wHeader2};
    text-align: center;
  }
`;

export const Carousel = styled.div`
  padding-top: 50px;
  display: flex;
  flex-direction: row;
  transform-style: preserve-3d;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  transition: left 1s;
  //gap: 16px;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::before,
  &::after {
    flex: 0 0 calc(50% - 328px / 2);
    width: 100%;
    content: "";
  }
  ${DESKTOP} {
    display: none;
  }
`;

export const Responsibility = styled.div`
  width: 300px;
  height: 345px;
  margin-left: 0;
  display: flex;
  background-color: white;
  flex-direction: column;
  scroll-snap-align: center;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(129, 137, 143, 0.12);
  margin-right: 16px;
  :nth-of-type(4) {
    margin-right: 0;
  }
`;

export const Number = styled.span`
  ${MobileBody1};
  color: ${swc.blue} !important;
  ${DESKTOP} {
    ${WebBody1};
  }
`;

export const Session = styled.p`
  ${MobileTitle1};
  padding-top: 8px;
  ${DESKTOP} {
    ${WebTitle1};
  }
`;

export const Image = styled.div`
  position: relative;
  width: 252px;
  height: 140px;
  border-radius: 8px;
  margin-top: 20px;
  overflow: hidden;
  ${DESKTOP} {
    width: 440px;
    height: 200px;
  }
`;

export const Desc = styled.p`
  ${MobileBody2};
  color: ${grayScale.gray80} !important;
  padding-top: 20px;
  ${DESKTOP} {
    ${WebBody2};
  }
`;

export const Grid = styled.div`
  display: none;
  ${DESKTOP} {
    padding-top: 80px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 1024px;
    gap: 24px;
    margin: 0 auto;
  }
`;

export const Card = styled.div`
  ${DESKTOP} {
    padding: 30px;
    width: 500px;
    height: 414px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 8px 24px rgba(129, 137, 143, 0.12);
  }
`;

export const PlusImage = styled.div`
  margin: 20px auto;
  height: 100px;
  width: 100px;
  ${DESKTOP} {
    margin: 40px auto;
    height: 132px;
    width: 132px;
  }
`;
